import * as yup from "yup";
import "yup-phone-lite";

const contactSchema = yup.object().shape({
  contactName: yup
    .string()
    .min(2, "trop petit")
    .max(30, "trop long!")
    .required("Nom manquant"),

  contactEmail: yup
    .string()
    .email("adresse email incorrecte")
    // \. - Le point séparateur du domaine et extension (ex: .com, .fr, .io, .org, ...)
    // \ échappe le point (sinon il signifierait "n'importe quel caractère" en regex)
    // [a-zA-Z] : uniquement des lettres
    // {2,} : au minimum 2 caractères
    // $/ - Fin de la chaîne
    .matches(/\.[a-zA-Z]{2,}$/, "adresse email incorrecte")
    .required("adresse email manquante"),

  contactPhone: yup
    .string()
    .phone("FR", "numéro incorrect")
    .required("Numéro de téléphone manquant"),

  contactSubject: yup.string().required("Objet manquant"),

  contactMessage: yup
    .string()
    .min(5, "message trop court")
    .max(1000, "message trop long!")
    .required("Message manquant"),
});

export default contactSchema;
